<p-toast />
<hr class="mt-0" />
<form [formGroup]="form" (submit)="onSave()" class="w-full">
  <div class="flex flex-column gap-2 mb-4">
    <label for="name">{{ 'layout.configurations.roles.name' | translate }} <span class="required">*</span></label>
    <input
      id="name"
      formControlName="name"
      type="text"
      pInputText
      [placeholder]="'layout.configurations.roles.name' | translate"
      class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('name').invalid }" />
    <div *ngIf="isInvalid('name').invalid" class="text-red-600">{{ isInvalid('name').message | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label for="description">{{ 'layout.configurations.roles.description' | translate }} <span class="required">*</span></label>
    <input
      id="description"
      formControlName="description"
      type="text"
      pInputText
      [placeholder]="'layout.configurations.roles.description' | translate"
      class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('description').invalid }" />
    <div *ngIf="isInvalid('description').invalid" class="text-red-600">{{ isInvalid('description').message | translate }}</div>
  </div>
  <hr />
  <div class="flex justify-content-end mb-4">
    <p-button type="submit" icon="pi pi-check" [label]="'layout.configurations.roles.addRole.save' | translate"></p-button>
  </div>
</form>